import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromCustomers from './reducers/customers.reducer';
import { EffectsModule } from '@ngrx/effects';
import { CustomersEffects } from './effects/customers.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromCustomers.customersFeatureKey, fromCustomers.reducer),
    EffectsModule.forFeature([CustomersEffects]),
  ],
})
export class CustomersStoreModule {}
